import { IconChoiceModal } from './IconChoiceModal';

export default IconChoiceModal;
